import { render, staticRenderFns } from "./NumericAttributeEditor.vue?vue&type=template&id=897056c8"
import script from "./NumericAttributeEditor.vue?vue&type=script&lang=js"
export * from "./NumericAttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports